import { Box, Paper, Typography, styled } from '@mui/material';
import { FC } from 'react';
import { IconButton } from 'shared/ui/IconButton';
import { ColorPalette } from 'shared/consts/colorPalette';

type LabelProps = {
	title: string;
	description?: string;
	editHandler?: () => void;
	deleteHandler?: () => void;
};

const Label: FC<LabelProps> = ({ title, description, editHandler, deleteHandler }) => {
	return (
		<Paper
			sx={{
				'display': 'flex',
				'flexDirection': 'column',
				'padding': '20px 25px',
				'boxShadow': '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
				'backgroundColor': ColorPalette.white,
				'borderRadius': '10px',
				'margin': '5px 0',
				'gap': '20px',
				'@media screen and (min-width: 1441px)': {
					padding: '30px',
				},
			}}
		>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<TitleStyled variant={'body1'} color={ColorPalette.astronaut}>
					{title}
				</TitleStyled>
				<Box sx={{ display: 'flex', gap: '5px' }}>
					{editHandler && (
						<IconButton
							iconId={'choose_subcategory'}
							sxWrapper={{
								height: 'auto',
								width: 'auto',
								backgroundColor: 'transparent',
							}}
							onClick={() => editHandler && editHandler()}
						/>
					)}
					{deleteHandler && (
						<IconButton
							iconId={'trush_icon_red'}
							sxWrapper={{
								height: 'auto',
								width: 'auto',
								backgroundColor: 'transparent',
							}}
							onClick={() => deleteHandler && deleteHandler()}
						/>
					)}
				</Box>
			</Box>
			<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
				<TextStyled variant={'body1'} color={ColorPalette.baliHai}>
					{description}
				</TextStyled>
			</Box>
		</Paper>
	);
};

export default Label;

const BaseTextStyled = styled(Typography)`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

const TitleStyled = styled(BaseTextStyled)`
	width: 75%;
`;

const TextStyled = styled(BaseTextStyled)`
	width: 100%;
`;
